export const MaxIgVideoLengthValue = 60; // allowed video length for direct publishing in feed

export const VideoLengthLimits = {
  facebook: 40 * 60, // 40 mins
  twitter: 140, // 140 sec
  linkedIn: 30 * 60 // 30 mins (testing length limits for new API)
};

export enum MaxLimits {
  'QUERY' = 100,
  'UPLOAD' = 200
}

export enum MediaUploadStatus {
  'PENDING' = 'PENDING',
  'UPLOADING' = 'UPLOADING',
  'UPLOADING_DONE' = 'UPLOADING_DONE',
  'COMPLETING' = 'COMPLETING',
  'COMPLETED' = 'COMPLETED',
  'FAILED' = 'FAILED',
  'DELETED' = 'DELETED'
}

export enum PhotoExtensions {
  'JPEG' = 'jpeg',
  'JPG' = 'jpg',
  'PNG' = 'png',
  'GIF' = 'gif',
  'WEBP' = 'webp'
}

export enum VideoExtensions {
  '3G2' = '3g2',
  '3GP' = '3gp',
  '3GPP' = '3gpp',
  'ASF' = 'asf',
  'AVI' = 'avi',
  'DAT' = 'dat',
  'DIVX' = 'divx',
  'DV' = 'dv',
  'F4V' = 'f4v',
  'FLV' = 'flv',
  'GIF' = 'gif',
  'M2TS' = 'm2ts',
  'M4V' = 'm4v',
  'MKV' = 'mkv',
  'MOD' = 'mod',
  'MOV' = 'quicktime',
  'MP4' = 'mp4',
  'MPE' = 'mpe',
  'MPEG' = 'mpeg',
  'MPEG4' = 'mpeg4',
  'MPG' = 'mpg',
  'MTS' = 'mts',
  'NSV' = 'nsv',
  'OGM' = 'ogm',
  'OGV' = 'ogv',
  'QT' = 'qt',
  'TOD' = 'tod',
  'TS' = 'ts',
  'VOB' = 'vob',
  'WMV' = 'wmv'
}

export enum FindImagesSource {
  'PIXABAY' = 'pixabay',
  'UNSPLASH' = 'unsplash',
  'GIPHY' = 'giphy'
}

export enum ErrorCodeSummaryText {
  'file-invalid-type' = 'Invalid file extension',
  'file-too-large' = 'File too large',
  'file-too-small' = 'File too small',
  'too-many-files' = 'Too many files to upload'
}
